import { SEC_ApiCall } from '../func.js';

/**
 * Load the read-only dashboard rota payload for one rota family.
 * @param {string} masterRotaId - Stable rota-family identifier.
 * @returns {Promise<object>} API response payload.
 */
export function getDashboardRota(masterRotaId) {
  return SEC_ApiCall('rotas/dashboard/view', { masterRotaId });
}
